import { renderApp } from '@/app';
import { welcome } from '@/app/config/welcome';
import { startVersionChecker } from './version-checker';

import('@/app/app').then(({ default: App }) => {
  renderApp(App);
  startVersionChecker(60_000);
});
welcome();
